import { ChartActionsCreator } from "./chart/chart.actions";


export const MusicActionsCreator = {
	...ChartActionsCreator
}
